<kendo-card [width]="'500px'" class="margin-right-15 margin-left-15 card-height" style="margin-top: 10px; margin-bottom: 10px">
  <kendo-card-header class="k-hbox">
    <h1 kendoCardTitle class="color-primary">Patient Form</h1>
  </kendo-card-header>
  <kendo-card-body>
    <form [formGroup]="formGroup">
      <div class="row-wrap" [style.gap.px]="10">
        <kendo-formfield [style.max-width.px]="200">
          <kendo-floatinglabel text="Last Name*">
            <kendo-textbox formControlName="lname" required (focus)="onFieldFocused('lname')" [disabled]="searchComplete" (click)="onFieldClicked('lname')" (keyup)="onKeyDown($event, 'lname')"
            [ngClass]="{ 'focused-input': isFieldFocused('lname') }"></kendo-textbox>
          </kendo-floatinglabel>
          @if (formGroup.get('lname').hasError('required')) {
            <kendo-formerror>Error: Last Name is required
            </kendo-formerror>
          }
        </kendo-formfield>
        <kendo-formfield [style.max-width.px]="200">
          <kendo-floatinglabel text="First Name*">
            <kendo-textbox formControlName="fname" required (focus)="onFieldFocused('fname')" (click)="onFieldClicked('fname')" (keyup)="onKeyDown($event, 'fname')" [ngClass]="{ 'focused-input': isFieldFocused('fname') }"
            [disabled]="searchComplete"></kendo-textbox>
          </kendo-floatinglabel>
          @if (formGroup.get('fname').hasError('required')) {
            <kendo-formerror>Error: First Name is required
            </kendo-formerror>
          }
        </kendo-formfield>
        <kendo-formfield [style.max-width.px]="200">
          <kendo-floatinglabel text="MRN">
            <kendo-textbox formControlName="mrn" (focus)="onFieldFocused('mrn')" (click)="onFieldClicked('mrn')" (keyup)="onKeyDown($event, 'mrn')" [ngClass]="{ 'focused-input': isFieldFocused('mrn') }"  [disabled]="searchComplete"></kendo-textbox>
          </kendo-floatinglabel>
        </kendo-formfield>
        <kendo-formfield [style.max-width.px]="200">
          <kendo-label text="Date of Birth*">
            <kendo-datepicker format="MM/dd/yyyy" [disabled]="searchComplete"
              [enableMouseWheel]="false" (focus)="onFieldFocused('dob')" (click)="onFieldClicked('dob')" (keyup)="onKeyDown($event, 'dob')" [ngClass]="{ 'focused-input': isFieldFocused('dob') }"
              formControlName="dob" [max]="maxDate">
            </kendo-datepicker>
          </kendo-label>
          <!--                      <kendo-formerror *ngIf="patientSearchForm.get('dob').hasError('required')">Error: Date of Birth is required-->
        <!--                      </kendo-formerror>-->
      </kendo-formfield>
      <kendo-formfield [style.max-width.px]="200">
        <kendo-floatinglabel text="Phone">
          <kendo-maskedtextbox [mask]="phoneMask" (focus)="onFieldFocused('phone')" [ngClass]="{ 'focused-input': isFieldFocused('phone') }"
          formControlName="phone" [disabled]="searchComplete"></kendo-maskedtextbox>
        </kendo-floatinglabel>
      </kendo-formfield>
      <kendo-formfield [style.max-width.px]="200">
        <kendo-floatinglabel text="Gender">
          <kendo-combobox [data]="gender" [textField]="'text'"
            (focus)="onFieldFocused('gender')" [ngClass]="{ 'focused-input': isFieldFocused('gender') }"
            [valueField]="'value'" [allowCustom]="false"
            placeholder="Gender" [disabled]="searchComplete" formControlName="gender">
          </kendo-combobox>
        </kendo-floatinglabel>
      </kendo-formfield>
    </div>
    <kendo-panelbar [style.margin-top.px]="15">
      <kendo-panelbar-item  title="Additional Demographics" [expanded]="false">
        <ng-template kendoPanelBarContent>
          <div class="row-wrap" [style.padding.px]="10" [style.gap.px]="10">
            <kendo-formfield [style.max-width.px]="200">
              <kendo-floatinglabel text="Middle Name">
                <kendo-textbox formControlName="mname" (focus)="onFieldFocused('mname')" [ngClass]="{ 'focused-input': isFieldFocused('mname') }"  [disabled]="searchComplete"></kendo-textbox>
              </kendo-floatinglabel>
            </kendo-formfield>
            <kendo-formfield [style.max-width.px]="200">
              <kendo-floatinglabel text="Suffix">
                <kendo-textbox formControlName="suffix" (focus)="onFieldFocused('suffix')" [ngClass]="{ 'focused-input': isFieldFocused('suffix') }"  [disabled]="searchComplete"></kendo-textbox>
              </kendo-floatinglabel>
            </kendo-formfield>
                            <!--    *ngIf="abbyyForm !== undefined-->
                            <!--    && currentFormType  === 'POLST'"-->
                            <kendo-formfield [style.max-width.px]="200">
                                <kendo-floatinglabel text="Mailing Address from POLST" style="width: 400px; margin-top: 10px">
                                    <kendo-textbox formControlName="mailing_address" (focus)="onFieldFocused('mailing_address')" [ngClass]="{ 'focused-input': isFieldFocused('mailing_address') }"  [disabled]="searchComplete"></kendo-textbox>
                                </kendo-floatinglabel>
                            </kendo-formfield>
                        </div>
                        <div class="row-wrap" [style.padding.px]="10" [style.gap.px]="10">
                            <kendo-formfield [style.max-width.px]="200">
                                <kendo-floatinglabel text="Street">
                                    <kendo-textbox formControlName="street" (focus)="onFieldFocused('street')" [ngClass]="{ 'focused-input': isFieldFocused('street') }"  [disabled]="searchComplete"></kendo-textbox>
                                </kendo-floatinglabel>
                            </kendo-formfield>
                            <kendo-formfield [style.max-width.px]="200">
                                <kendo-floatinglabel text="City">
                                    <kendo-textbox formControlName="city" (focus)="onFieldFocused('city')" [ngClass]="{ 'focused-input': isFieldFocused('city') }"  [disabled]="searchComplete"></kendo-textbox>
                                </kendo-floatinglabel>
                            </kendo-formfield>
                            <kendo-formfield>
                                <kendo-floatinglabel text="State">
                                    <kendo-combobox [data]="states" [textField]="'text'"
                                                    style="width: 200px"
                  (focus)="onFieldFocused('state')" [ngClass]="{ 'focused-input': isFieldFocused('state') }"
                  [valueField]="'value'" [allowCustom]="false"
                  [disabled]="searchComplete"
                  placeholder="State"
                  formControlName="state">
                </kendo-combobox>
              </kendo-floatinglabel>
            </kendo-formfield>
            <kendo-formfield [style.max-width.px]="200">
              <kendo-floatinglabel text="Zip">
                <kendo-textbox formControlName="zip" (focus)="onFieldFocused('zip')" [ngClass]="{ 'focused-input': isFieldFocused('zip') }"  [disabled]="searchComplete"></kendo-textbox>
              </kendo-floatinglabel>
            </kendo-formfield>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </form>
</kendo-card-body>
</kendo-card>
